import React from "react";
import MainDashboard from "../Pages/MainDashboard";
import ProfileSettings from "../Components/Common/ProfileSettings";
import UserManagement from "../Pages/UserManagement";
import UserProfile from "../Pages/UserManagement/UserProfile";
import AlbumImages from "../Pages/UserManagement/AlbumImages";
import PhotoBookImages from "../Pages/UserManagement/PhotoBookImages";
import PageNotFound from "../Pages/NotFound";
import { mainNav } from "../Components/Common/Navbar";
import StaticPageManagement from "../Pages/StaticPageManagement/index";
import NotificationManagement from "../Pages/NotificationManagement";
import ContactUsManagement from "../Pages/ContactUsManagement";

const ProtectedRoutes = [
  {
    path: "/dashboard",
    index: false,
    element: <MainDashboard isMainNav={true} />,
  },
  {
    path: "/profile-settings",
    index: false,
    element: <ProfileSettings navigationBar={mainNav} isMainNav={true} />,
  },
  {
    path: "/user-management",
    index: false,
    element: <UserManagement navigationBar={mainNav} isMainNav={true} />,
  },
  {
    path: "/notification-management",
    index: false,
    element: (
      <NotificationManagement navigationBar={mainNav} isMainNav={true} />
    ),
  },
  {
    path: "/user/:id",
    index: false,
    element: (
      <UserProfile type="user" navigationBar={mainNav} isMainNav={true} />
    ),
  },
  {
    path: "/albumImages/:id",
    index: false,
    element: <AlbumImages navigationBar={mainNav} isMainNav={true} />,
  },
  {
    path: "/photobookImages/:id",
    index: false,
    element: <PhotoBookImages navigationBar={mainNav} isMainNav={true} />,
  },
  {
    path: "/staticpage",
    index: false,
    element: <StaticPageManagement navigationBar={mainNav} isMainNav={true} />,
  },
  {
    path: "/contact-us",
    index: false,
    element: <ContactUsManagement navigationBar={mainNav} isMainNav={true} />,
  },
  { path: "*", element: <PageNotFound /> },
];

export default ProtectedRoutes;
